import { appLocationParseQueryParams } from 'v5/core/list-query/appListQueries';
import { createLocationService } from './LocationService.impl';

export const myLocationService = createLocationService({
  parseQueryParams: appLocationParseQueryParams
});
